module.exports = __webpack_public_path__ + "static/media/raixer.40a5991d.png";